import * as React from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Theme, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {
  AppBar as MuiAppBar,
  Toolbar,
  Box,
  IconButton,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import valmetLogo from '../assets/valmet_logo@3x.png';
import { AuthContext } from '../store/authContext';
import Navigation from '../navigation/Navigation';
import HideOnScroll from './HideOnScroll';


const AppBar: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const { t } = useTranslation();
  const history = useNavigate();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const { logout, isLoggedIn } = useContext(AuthContext);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    logout();
    history('/');
    handleClose();
  };

  return (
    <HideOnScroll>
      <MuiAppBar position="fixed"  sx={{
          width: '100%',
          backgroundColor: theme.palette.background.paper,
          boxShadow: '0px 4px 4px #0000003D',
          zIndex: theme.zIndex.drawer + 1,
      }}>
        <Toolbar   sx={(theme) => ({
            display: 'flex',
            paddingRight: 0,
        })}>
          <img src={valmetLogo} alt="Valmet logo"  style={{height: '3rem'}}/>
          <Box sx={{
                   marginLeft: 'auto',
                   display: 'flex',
                   height: '100%',
               }}>
            {!isSmall && isLoggedIn && <Navigation />}
            <IconButton
              color="secondary"
              onClick={handleClick}
              sx={{
                  alignSelf: 'center',
                  marginRight: theme.spacing(1),
                  marginLeft: theme.spacing(2),
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
              BackdropProps={{ invisible: false }}
              sx={{
                  borderRadius: 2,
              }}
            >
              {isLoggedIn && (
                <MenuItem
                  onClick={handleLogout}
                  sx={{
                      paddingRight: 64
                  }}
                >
                  <ListItemIcon  sx={{
                                  minWidth: 36,
                                }}>
                    <ExitToAppIcon />
                  </ListItemIcon>

                  <ListItemText primary={t('auth:logout')} />
                </MenuItem>
              )}
            </Menu>
          </Box>
        </Toolbar>
        {isSmall && isLoggedIn && <Navigation />}
      </MuiAppBar>
    </HideOnScroll>
  );
};

export default AppBar;
